import { normalize } from 'normalizr';

import {
  accountSchema,
  billingAddressSchema,
  contactSchema,
  facilitySchema,
} from './entities';

export const types = {
  ACCOUNT_RECEIVE: 'contacts/accountDetails/entities/ACCOUNT_RECEIVE',
  BILLING_ADDRESS_RECEIVE:
    'contacts/accountDetails/entities/BILLING_ADDRESS_RECEIVE',
  CONTACT_RECEIVE: 'contacts/accountDetails/entities/CONTACT_RECEIVE',
  FACILITY_RECEIVE: 'contacts/accountDetails/entities/FACILITY_RECEIVE',
};

export const entitiesStore = {
  receiveAccount: (payload) => ({
    type: types.ACCOUNT_RECEIVE,
    payload: {
      ...normalize(payload, accountSchema),
    },
  }),
  receiveBillingAddress: (payload) => ({
    type: types.BILLING_ADDRESS_RECEIVE,
    payload: {
      ...normalize(payload, billingAddressSchema),
    },
  }),
  receiveContact: (payload) => ({
    type: types.CONTACT_RECEIVE,
    payload: {
      ...normalize(payload, contactSchema),
    },
  }),
  receiveFacility: (payload) => ({
    type: types.FACILITY_RECEIVE,
    payload: {
      ...normalize(payload, facilitySchema),
    },
  }),
};
